import { z } from 'zod';

function isNonEmpty<T>(a: readonly T[]): a is [T, ...T[]] {
  return a.length > 0;
}

export function toZodEnum(keys: string[]) {
  if (isNonEmpty(keys)) {
    return z.enum(keys);
  } else {
    // TODO: this should ideally be explicit in callers we want it to happen in,
    // but ensuring toZodEnum is only called when non-empty arrays can be
    // guaranteed is out of scope for this tslint bump
    return z.string().optional();
  }
}

export function getDefaultValue<T>(zodSchema: z.ZodType<T>): T | undefined {
  if (zodSchema instanceof z.ZodDefault) {
    return zodSchema._def.defaultValue();
  }
  return undefined;
}

export function getInitialValues(fieldsets: Fieldset[]) {
  const defaults: {
    [x: string]: any;
  } = {};

  for (const fieldset of fieldsets || []) {
    for (const field of fieldset.fields) {
      if (field.type === 'checkbox_group') {
        for (const subfield of field.fields) {
          defaults[subfield.name] = getDefaultValue(unref(subfield.schema));
        }
        continue;
      }

      defaults[field.name] = getDefaultValue(unref(field.schema));
    }
  }

  return defaults;
}
